import axios from 'axios';
import { toast } from 'react-toastify';
import { IS_LOADING, TEAM_MANAGER_LIST_SUCCESS, TEAM_MANAGER_LIST_ERROR, TEAM_MANAGER_UPDATE_SUCCESS, TEAM_MANAGER_UPDATE_ERROR, TEAM_MANAGER_FILTER_SUCCESS, TEAM_MANAGER_FILTER_ERROR, TEAM_MANAGER_FILTER_LIST_SUCCESS, TEAM_MANAGER_FILTER_LIST_ERROR } from './Type';
import { baseUrlPostGres } from '../constant';
import { apiHeader } from './ApiHeader';
import 'react-toastify/dist/ReactToastify.css';
import HandleError from '../HandleError';
import { apiVersion } from 'src/utils/apiVersion';

export const GetTeamManagerList = (page, size, type, data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/team/${type}_team_list?page=${page}&limit=${size}`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: TEAM_MANAGER_LIST_SUCCESS,
                payload: response
            })
            dispatch({
                type: TEAM_MANAGER_FILTER_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: TEAM_MANAGER_LIST_ERROR,
                payload: errors
            })
            dispatch({
                type: TEAM_MANAGER_FILTER_LIST_ERROR,
                payload: errors
            })
        })
}

export const ResetGetTeamManagerList = () => async (dispatch) => {
    dispatch({
        type: TEAM_MANAGER_LIST_SUCCESS,
        payload: {}
    })
    dispatch({
        type: TEAM_MANAGER_FILTER_LIST_SUCCESS,
        payload: {}
    })
}

export const UpdateTeamManager = (data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/team/team_add`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: TEAM_MANAGER_UPDATE_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: TEAM_MANAGER_UPDATE_ERROR,
                payload: errors
            })
        })
}

export const ResetUpdateTeamManager = () => async (dispatch) => {
    dispatch({
        type: TEAM_MANAGER_UPDATE_SUCCESS,
        payload: {}
    })
}

export const FilterTeamManager = (type, data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/team/${type}_team`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: TEAM_MANAGER_FILTER_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: TEAM_MANAGER_FILTER_ERROR,
                payload: errors
            })
        })
}